"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingTask = void 0;
const logger_1 = require("./logger");
/*
    Create a task that will repeat every 'intervalMs'.
 */
class RepeatingTask {
    constructor(config) {
        this.stopped = true;
        this.errorThreshold = 1;
        this.errorCount = 0;
        this.task = config.task;
        this.taskName = config.taskName;
        this.intervalMs = config.intervalMs;
        this.errorThreshold = config.errorThreshold || this.errorThreshold;
        this.onError = config.onError;
        logger_1.logger.info(`Created new RepeatingTask taskName=${this.taskName} with intervalMs=${this.intervalMs} errorThreshold=${this.errorThreshold}`);
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.stopped) {
                logger_1.logger.info(`RepeatingTask taskName=${this.taskName} already started. interval=${this.interval}`);
                return;
            }
            this.stopped = false;
            yield this.executeTask();
            this.interval = window.setInterval(() => __awaiter(this, void 0, void 0, function* () { return yield this.executeTask(); }), this.intervalMs);
            logger_1.logger.info(`RepeatingTask taskName=${this.taskName} started. interval=${this.interval}`);
        });
    }
    stop() {
        clearInterval(this.interval);
        this.stopped = true;
        logger_1.logger.info(`RepeatingTask taskName=${this.taskName} is stopped`);
    }
    executeTask() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stopped) {
                this.stop();
            }
            try {
                yield this.task();
            }
            catch (e) {
                logger_1.logger.error(`RepeatingTask taskName=${this.taskName} errorCount=${this.errorCount} of errorThreshold=${this.errorThreshold} has failed with exception=${e}`);
                if (this.errorCount >= this.errorThreshold) {
                    logger_1.logger.error(`RepeatingTask taskName=${this.taskName} errorCount=${this.errorCount} has exceeded errorThreshold=${this.errorThreshold} with exception=${e}.  Stopping Task.`);
                    this.stop();
                    this.onError(e);
                }
            }
        });
    }
}
exports.RepeatingTask = RepeatingTask;
//# sourceMappingURL=repeating_task.js.map